.hero {
  position: relative;
  padding: 20px var(--pad) var(--pad);
  color: var(--hero-fg);
  background: var(--hero-bg);
  border: 1px solid var(--card-border);
  border-radius: var(--r-xl);
  box-shadow: var(--shadow-float);
  overflow: hidden;
}

/* Эмблема водяным знаком — только там, где слева остаётся место.
   Включается признаком: на карточке с широким числом (суммой) она
   ложится прямо на него. Лежит под содержимым и не ловит нажатия. */
.emblem {
  position: absolute;
  top: 2px;
  right: -34px;
  /* Едва проступает: это фон карточки, а не её содержание. При большей
     плотности знак спорит с числом дней, поверх которого лежит. */
  opacity: 0.16;
  pointer-events: none;
}

.top {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.figure {
  position: relative;
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 18px;
}

.number {
  font-size: 46px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}

/* Фраза вместо числа: «Доступ закрыт» кеглем цифры не помещается в строку. */
.textual {
  font-size: 28px;
  letter-spacing: -0.01em;
}

.unit {
  font-size: 15px;
  color: var(--hero-dim);
}

.until {
  position: relative;
  margin-top: 6px;
  font-size: 13px;
  /* Моноширинный здесь не годится: дата набрана словами, и «18 октября»
     в нём выглядит распечаткой. Ровные цифры даёт tabular-nums. */
  font-variant-numeric: tabular-nums;
  color: var(--hero-dim);
}

.track {
  position: relative;
  height: 4px;
  margin: 18px 0 16px;
  background: var(--hero-line);
  border-radius: 2px;
  overflow: hidden;
}

.fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent) 0%, var(--accent-bright) 100%);
  border-radius: 2px;
}

.actions {
  position: relative;
  display: flex;
  gap: 10px;
}

/* Без полосы срока кнопку от текста отделять нечему — отступ задаётся явно. */
.until + .actions {
  margin-top: 18px;
}
